module.exports = __webpack_public_path__ + "static/media/address-a-red-icon.b3555f40.svg";